import Component from '../colorz/Component';

import device from '../colorz/utils/device';

module.exports = class HairstyleTabs extends Component {
    onInit( el, args) {
        // Initializations
        this.onClick = this.onClick.bind( this );

        this.el = el;
        this.tabContainer = this.el.querySelector('.tabs__list' );
        this.tabContent = this.el.querySelectorAll('.js-tab-content');
        this.tabList = this.el.querySelectorAll('.js-tab');
        this.active = 0;
    }

    onReady() {
        this.el.removeChild(this.tabContainer);
        this.el.insertBefore(this.tabContainer, this.el.querySelector('.js-tab-content'));

        this.setActive();

        for (var i = 0; i < this.tabList.length; i++){
            this.tabList[i].addEventListener(device.pointerdown, this.onClick);
        }
    }

    onClick(e) {
        this.unsetActive();

        if (this.tabContainer.contains(e.target)){
            this.active = e.target.dataset.id;
        }

        this.setActive();
    }

    setActive(){
        for (var i = 0; i < this.tabContent.length; i ++){
            if (this.tabContent[i].dataset.id == this.active) {
                this.tabContent[i].classList.add('active');
            }
        }
    }

    unsetActive(){
        for (var i = 0; i < this.tabContent.length; i ++){
            this.tabContent[i].classList.remove('active');
        }
    }
};